import { useTheme } from '@mui/material';
import IconSax from 'components/IconSax/IconSax';

export default function SelectedBadge() {
  const theme = useTheme();
  return (
    <IconSax
      name="tick-circle"
      sx={{
        color: 'white',
        backgroundColor: theme.palette.primary.main,
        borderRadius: '50%',
      }}
    />
  );
}
